module.exports = __webpack_public_path__ + "media/images/bitmap/cloud-flare-badge-b67a86cb82bead90b4a3558c1e2979c1.png";